
// Add a message to the chat
function moveMessageScroll() {
    if ($('.year-seat-messages .messages-wrapper.active').length) {
        var messages = $('.year-seat-messages .messages-wrapper.active');
        var height = messages[0].scrollHeight;
        messages.scrollTop(height);
    }

}

moveMessageScroll();
$(window).resize(function () {
    moveMessageScroll();
});


var yearSeatMessageShifting;
$('body').on('keydown', '.year-seat-messages textarea[name="new_message"]', function(e) {
    if(e.keyCode === 16) {
    	yearSeatMessageShifting = true;
    }
});


$('body').on('keyup', '.year-seat-messages textarea[name="new_message"]', function(e) {
	if(e.keyCode === 16) {
		yearSeatMessageShifting = false;
	}

	if(e.keyCode === 13 && !yearSeatMessageShifting) {
		e.preventDefault();

		var input = $('.year-seat-messages textarea[name="new_message"]');
		var message = input.val();
		input.val('');

		if(message.length > 1) {
			$('.year-seat-messages .messages-wrapper.active .processing').show();
			moveMessageScroll();

			$.ajax({
				type : 'POST',
				url : $('.year-seat-messages').attr('data-action'),
				data : {
					'_token': $('meta[name="csrf-token"]').attr('content'),
					'message': message
				},
				dataType : 'json',
				success : function(data) {
					console.log(data);
					if(data.success) {
						var message = data.message;
						$('.year-seat-messages .messages-wrapper.active .processing').before(`<li data-message="${message.year_seat_message}" class="${message.me ? 'me' : ''}">
									<p>${message.message}</p>
									<time>
										${message.messenger} &bull; ${message.time}
									</time>
								</li>`);
                        $('.year-seat-messages .messages-wrapper.active .processing').hide();
						moveMessageScroll();
					}
				},
				error : function(request) {
					console.log(request.responseText);
				}
			});
		}
	}
});

$('body').on('change', '.year-seat-messages .canned-message', function() {
$('.year-seat-messages textarea[name="new_message"]').val($(this).val());
return false;
});

$('body').on('click', '.hide-year-seat-messages', function() {
    $('.year-seat-messages-wrapper').hide();
    return false;
});


$('body').on('change', '.manage-year-seat .add-payment input[name="method"]', function () {
    var method = $(this).val();

    $('.manage-year-seat .add-payment .method').find('input, select').removeClass('required');
    $('.manage-year-seat .add-payment .method').find('input, select').prop('disabled', true);
    $('.manage-year-seat .add-payment .method').addClass('hidden');

    $('.manage-year-seat .add-payment .method[data-method="' + method + '"]').removeClass('hidden');
    $('.manage-year-seat .add-payment .method[data-method="' + method + '"]').find('input, select').prop('disabled', false);
    $('.manage-year-seat .add-payment .method[data-method="' + method + '"]').find('input, select').each(function () {
        var input = $(this);
        if (input.attr('data-required')) {
            input.addClass('required');
        }
    });
});

function calculateSeatPayments(totalAmount = 0) {
    var date;

    $('.payment-item').each(function() {
        var paymentItem = $(this);
        var amount = parseFloat($('[name="amount[]"]', paymentItem).val());
        if(!isNaN(amount)) {
            totalAmount += amount;
        }

        if (!date && $('[name="payment_date[]"]', paymentItem).val()) {
            date = new Date($('[name="payment_date[]"]', paymentItem).val());
        }
    });

    // calcuate per payment
    var perPayment = totalAmount / $('.payment-item').length;
    $('.payment-item').each(function () {
        var paymentItem = $(this);
        $('[name="amount[]"]', paymentItem).val(perPayment.toFixed(2));
        $('[name="payment_date[]"]', paymentItem).val(date.toDateString());
        date.setMonth(date.getMonth() + 1);
    });
}

var yearSeatPaymentItem = `<div class="payment-item item">
    <a href="" class="remove-payment-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
    <a href="" class="add-payment-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

    <ul class="fields no-padding">
        <li class="quarter filled">
            <input type="tel" name="amount[]" class="required">
            <span>Amount</span>
        </li>

        <li class="quarter filled">
            <input type="text" name="payment_date[]" class="required mask" data-placeholder="YYYY-MM-DD" data-mask="9999-99-99">
            <span>Payment Date</span>
        </li>

        <li class="quarter">
            <input type="tel" name="check_number[]">
            <span>Check Number</span>
        </li>

        <li class="quarter last">
            <input type="text" name="notes[]">
            <span>Notes</span>
        </li>
    </ul>
</div>`;

$('body').on('click', '.manage-year-seat .status-payments .add-payment-item-trigger', function () {
    var $this = $(this);
    var payment = $this.parents('.status-payments');
    payment.find('.setup-items').append(yearSeatPaymentItem);
    if ($('[name="auto_calculate"]').prop('checked') ) {
        calculateSeatPayments();
    }
    return false;
});

$('body').on('click', '.manage-year-seat .status-payments .add-payment-item-trigger-before', function () {
    var $this = $(this);
    // var payment = $this.parents('.status-payments');
    $this.parents('.payment-item').before(yearSeatPaymentItem);
    if ($('[name="auto_calculate"]').prop('checked')) {
        calculateSeatPayments();
    }
    return false;
});

$('body').on('click', '.manage-year-seat .remove-payment-item-trigger', function () {
    var $this = $(this);
    if ($('.payment-item').length > 1) {
        var amount = parseFloat($('[name="amount[]"]', $('.payment-item')).val());
        if (isNaN(amount)) {
            amount = 0;
        }
        $this.parents('.payment-item').remove();
        if ($('[name="auto_calculate"]').prop('checked')) {

            calculateSeatPayments(amount);
        }
    }
    return false;
});

$('body').on('click', '.manage-year-seat .add-qty', function() {
    var qty = parseInt($('.manage-year-seat .qty-wrapper input').val());
    var payment = $('.manage-year-seat .status-payments');
    if(isNaN(qty) || qty == 0) {
        return false;
    }

    for (let index = 0; index < qty; index++) {
        payment.find('.setup-items').append(yearSeatPaymentItem);
    }

    if ($('[name="auto_calculate"]').prop('checked')) {
        calculateSeatPayments();
    }
    
    return false;
});

// year-seat status 
$('body').on('click', '.open-change-year-seat-status', function () {
    var $this = $(this);
    var status = $this.parents('.status');
    status.addClass('updating');
    closeDropdown($this.parents('.status').attr('data-dropdown'));
    return false;
});

$('body').on('click', '.change-year-seat-status', function () {
    var $this = $(this);
    // var year-seat = $('.manage-year-seat');
    var status = $this.parents('.status');
    status.removeClass('updating');

    // update the status
    loading();
    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: {
            '_method': 'PUT',
            '_token': $('meta[name="csrf-token"]').attr('content'),
            'status': $this.attr('data-status')
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

// submit the payment
$('body').on('submit', '.manage-year-seat .add-payment form', function () {
    var $this = $(this);
    var card = $this.parents('.card');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };

    var error = false;

    card.find('.required').each(function () {
        if ($(this).val() === '') {
            error = true;
        }
    });

    if (error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }

    loading();
    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: fields,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            $this[0].reset();
            showError('Success', data.message);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-year-seat', function (data) {
    if ($('.manage-year-seat[data-year_seat="' + data.year_seat + '"]').length) {
        var element = $('.manage-year-seat[data-year_seat="' + data.year_seat + '"]');

        // update the status
        element.find('.year-seat [data-input="status"]').html(data.status);
        element.find('.year-seat [data-input="status"]').attr('data-color', data.status_color);

        // update the meta
        element.find('.year-seat [data-input="seat_name"]').html(data.seat_name);
        element.find('.year-seat [data-input="seat_hebrew_name"]').html(data.seat_hebrew_name);

        // update the form
        element.find('.year-seat [name="name"]').val(data.name);
        element.find('.year-seat [name="hebrew_name"]').val(data.hebrew_name);
        element.find('.year-seat [name="cost"]').val(data.cost);
        element.find('.year-seat [name="due_date"]').val(data.due_date);
        element.find('.year-seat [name="paid"]').prop('checked', data.paid ? true : false);
    }
});